import { useState } from "react";
import "./Services.css";

/* ================= IMAGES ================= */

/* HERO */
import heroImg from "../../assets/services/services-hero.jpg";

/* INTERIOR */
import i1 from "../../assets/interiors/interior1.jpg";
import i2 from "../../assets/interiors/interior2.jpg";
import i3 from "../../assets/interiors/interior3.jpg";
import i4 from "../../assets/interiors/interior4.jpg";
import i5 from "../../assets/interiors/interior5.jpg";
import i6 from "../../assets/interiors/interior6.jpg";
import i7 from "../../assets/interiors/interior7.jpg";
import i8 from "../../assets/interiors/interior8.jpg";
import i9 from "../../assets/interiors/interior9.jpg";
import i10 from "../../assets/interiors/interior10.jpg";
import i11 from "../../assets/interiors/interior11.jpg";
import i12 from "../../assets/interiors/interior12.jpg";

/* MODULAR */
import m1 from "../../assets/modular/modular1.jpg";
import m2 from "../../assets/modular/modular2.jpg";
import m3 from "../../assets/modular/modular3.jpg";
import m4 from "../../assets/modular/modular4.jpg";
import m5 from "../../assets/modular/modular5.jpg";
import m6 from "../../assets/modular/modular6.jpg";
import m7 from "../../assets/modular/modular7.jpg";
import m8 from "../../assets/modular/modular8.jpg";
import m9 from "../../assets/modular/modular9.jpg";
import m10 from "../../assets/modular/modular10.jpg";
import m11 from "../../assets/modular/modular11.jpg";
import m12 from "../../assets/modular/modular12.jpg";

/* ELECTRICAL */
import e1 from "../../assets/electrical/e1.jpg";
import e2 from "../../assets/electrical/e2.jpg";
import e3 from "../../assets/electrical/e3.jpg";
import e4 from "../../assets/electrical/e4.jpg";
import e5 from "../../assets/electrical/e5.jpg";
import e6 from "../../assets/electrical/e6.jpg";
import e7 from "../../assets/electrical/e7.jpg";
import e8 from "../../assets/electrical/e8.jpg";
import e9 from "../../assets/electrical/e9.jpg";
import e10 from "../../assets/electrical/e10.jpg";
import e11 from "../../assets/electrical/e11.jpg";
import e12 from "../../assets/electrical/e12.jpg";

/* POP */
import p1 from "../../assets/pop/p1.jpg";
import p2 from "../../assets/pop/p2.jpg";
import p3 from "../../assets/pop/p3.jpg";
import p4 from "../../assets/pop/p4.jpg";
import p5 from "../../assets/pop/p5.jpg";
import p6 from "../../assets/pop/p6.jpg";
import p7 from "../../assets/pop/p7.jpg";
import p8 from "../../assets/pop/p8.jpg";
import p9 from "../../assets/pop/p9.jpg";
import p10 from "../../assets/pop/p10.jpg";
import p11 from "../../assets/pop/p11.jpg";
import p12 from "../../assets/pop/p12.jpg";

export default function Services() {
  const [showInterior, setShowInterior] = useState(false);
  const [showModular, setShowModular] = useState(false);
  const [showElectrical, setShowElectrical] = useState(false);
  const [showPop, setShowPop] = useState(false);

  const renderGrid = (images, show) => (
    <>
      <div className="projects-grid">
        {images.slice(0, 4).map((img, i) => (
          <img key={i} src={img} alt="" />
        ))}
      </div>

      {show && (
        <div className="projects-grid">
          {images.slice(4).map((img, i) => (
            <img key={i} src={img} alt="" />
          ))}
        </div>
      )}
    </>
  );

  return (
    <div className="services-page">
      {/* HERO */}
      <section
        className="services-hero"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="services-hero-overlay">
          <h1>Our Services</h1>
          <p>End-to-end interior & modular solutions</p>
        </div>
      </section>

      {/* INTERIOR */}
      <section className="services-content">
        <div className="services-header">
          <h2>Interior Design</h2>
          <p>Luxury residential & commercial interiors</p>
        </div>

        {renderGrid(
          [i1,i2,i3,i4,i5,i6,i7,i8,i9,i10,i11,i12],
          showInterior
        )}

        <div className="services-btn-wrap">
          <button className="primary-btn" onClick={() => setShowInterior(!showInterior)}>
            {showInterior ? "View Less" : "View More"}
          </button>
        </div>
      </section>

      {/* MODULAR */}
      <section className="services-content">
        <div className="services-header">
          <h2>Modular Kitchen</h2>
          <p>Functional & premium modular solutions</p>
        </div>

        {renderGrid(
          [m1,m2,m3,m4,m5,m6,m7,m8,m9,m10,m11,m12],
          showModular
        )}

        <div className="services-btn-wrap">
          <button className="primary-btn" onClick={() => setShowModular(!showModular)}>
            {showModular ? "View Less" : "View More"}
          </button>
        </div>
      </section>

      {/* ELECTRICAL */}
      <section className="services-content">
        <div className="services-header">
          <h2>Electrical Solutions</h2>
          <p>Premium wiring & switch solutions</p>
        </div>

        {renderGrid(
          [e1,e2,e3,e4,e5,e6,e7,e8,e9,e10,e11,e12],
          showElectrical
        )}

        <div className="services-btn-wrap">
          <button className="primary-btn" onClick={() => setShowElectrical(!showElectrical)}>
            {showElectrical ? "View Less" : "View More"}
          </button>
        </div>
      </section>

      {/* POP */}
      <section className="services-content">
        <div className="services-header">
          <h2>POP & False Ceiling</h2>
          <p>Luxury ceiling & lighting designs</p>
        </div>

        {renderGrid(
          [p1,p2,p3,p4,p5,p6,p7,p8,p9,p10,p11,p12],
          showPop
        )}

        <div className="services-btn-wrap">
          <button className="primary-btn" onClick={() => setShowPop(!showPop)}>
            {showPop ? "View Less" : "View More"}
          </button>
        </div>
      </section>
    </div>
  );
}